'use client';

import { useAuthSession } from '@/lib/hooks/useAuth';
import { useBalanceVisibilityStore } from '@/lib/store/balance-visibility-store';

/**
 * Returns true only when the user is authenticated AND has balance visibility toggled off.
 * Guests always see balances regardless of the stored preference.
 */
export function useIsBalanceHidden(): boolean {
  const { isAuthenticated } = useAuthSession();
  const isBalanceHidden = useBalanceVisibilityStore((s) => s.isBalanceHidden);
  return isAuthenticated && isBalanceHidden;
}
